import { PropsWithChildren } from 'react';

export const FlyoutActions = ({ children }: PropsWithChildren) => <div className="gap-component-layout-box-spacing-gap-xs px-component-surfaces-flyout-container-spacing-padding-x py-component-surfaces-flyout-container-spacing-padding-y flex flex-col items-stretch">{children}</div>;
